import { parseOneText, type OneSpan } from '../lib/oneText'

/**
 * One's answer as elements, from `parseOneText` (ask-one v9).
 *
 * React elements only. One's text is model output and must never reach
 * dangerouslySetInnerHTML — the suite reads this file and the drawer for it.
 *
 * HLP-37: a `[words](#/route)` span becomes a link ONLY when its route is in
 * `links` - the routes of THIS answer's validated sources (lib/oneText.ts
 * `linkableRoutes`). The server already reduced every other link to its
 * words; this is the second wall, so a planted link that somehow reached the
 * client is still words. A link is a hash route, so it goes through the router.
 */
function Spans({ spans, links }: { spans: OneSpan[]; links: ReadonlySet<string> }) {
  return (
    <>
      {spans.map((s, i) =>
        s.href && links.has(s.href.slice(1)) ? (
          <a key={i} className="onetext__link" href={s.href}>{s.text}</a>
        ) : s.strong ? (
          <strong key={i}>{s.text}</strong>
        ) : (
          <span key={i}>{s.text}</span>
        ),
      )}
    </>
  )
}

const NONE: ReadonlySet<string> = new Set()

export function OneText({ text, links = NONE }: { text: string; links?: ReadonlySet<string> }) {
  const blocks = parseOneText(text)
  return (
    <div className="onemsg__body onetext">
      {blocks.map((b, i) => {
        if (b.kind === 'p')
          return (
            <p key={i} className="onetext__p">
              <Spans spans={b.spans} links={links} />
            </p>
          )
        const items = b.items.map((it, j) => (
          <li key={j}>
            <Spans spans={it} links={links} />
          </li>
        ))
        return b.kind === 'ul' ? (
          <ul key={i} className="onetext__list">{items}</ul>
        ) : (
          <ol key={i} className="onetext__list onetext__list--steps">{items}</ol>
        )
      })}
    </div>
  )
}
